import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { GIButton, Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { configs } from '../../../constants/configs/configs';
import { useStateCode } from '../../../hooks/useStateCode';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    actionLabel: string,
    isVoluntaryDisEnrollment: boolean,
    isCancelCoverage?: boolean,
    isChangeTerminationDate?: boolean,
    onModalClose?: () => void
}
export default function SubmitSuccess({
    actionLabel,
    isVoluntaryDisEnrollment,
    isCancelCoverage = false,
    isChangeTerminationDate = false,
    closeModal,
    onModalClose
}: IModalProps) {
    function onClose(e) {
        e?.preventDefault();
        onModalClose?.();
        closeModal('submitSuccess');
    }
    const navigate = useNavigate();
    const { isQuestionsTextVisible } = useStateCode();

    function onClickGoToDashboard() {
        navigate(configs.routes.INDPORTAL);
        closeModal('submitSuccess');
    }

    return (
        <Modal id="submitSuccessModal">
            <ConditionalRendering isTrue={isVoluntaryDisEnrollment}>
                <Modal.Header id="submitSuccessModalHeader"
                    titleId={isCancelCoverage ? "indportal.submitDisenroll.header.cancel" : "indportal.submitDisenroll.header.submit"}
                    onHide={onClose} />
            </ConditionalRendering>
            <Modal.Body id="submitSuccessModalBody">
                <p>
                    <FormattedMessage id={actionLabel} />
                </p>
                <ConditionalRendering isTrue={isQuestionsTextVisible}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.ifyouhaveanyquestions" />
                    </p>
                </ConditionalRendering>
            </Modal.Body>
            <Modal.Controls>
                <ConditionalRendering isTrue={!isVoluntaryDisEnrollment}>
                    <CapitalizedButton 
                        id="submitSuccessModalCloseButton" 
                        onClickHandler={onClose} 
                        variant="secondary" 
                        labelId={isChangeTerminationDate ? "button.close" : "button.cancel"} 
                    />
                </ConditionalRendering>
                <ConditionalRendering isTrue={isVoluntaryDisEnrollment}>
                    <CapitalizedButton 
                        id="submitSuccessModalGoToDashboardButton" 
                        onClickHandler={onClickGoToDashboard} 
                        variant="primary" 
                        labelId="button.go_to_dashboard" 
                        leftMargin={true} 
                    />
                </ConditionalRendering>
            </Modal.Controls>
        </Modal>
    );
}